<template>
	<div class="dbbj">
	<div class="bj">
		<div class="logo" style="margin-left: 20px;">
			<!-- <img src="../assets/img/logo.png" alt="" /> -->
			<img src="../assets/img/logo1.png" alt="" />
		</div>
		<div class="ipone"  style="margin-right: 20px;">
			<img src="../assets/img/phone.png" alt="" />
		</div>
	</div>
	<!-- 导航 -->
	<div class="nav">
		<el-menu 
		:default-active="activeIndex"
		mode="horizontal"
		background-color="#0789ea"
		text-color="#ffffff"
		active-text-color="#ffffff"
		@select="handleSelect">
		  <el-menu-item index="1">首页</el-menu-item>
		  <el-submenu style="border-bottom: none !important;" index="32">
		    <template slot="title">政务动态</template>
			<!-- 新闻中心 名字改成 时政要闻
				中心公告  改成   通知公告
				中心信息   改成   工作动态
			-->
		    <el-menu-item index="3">时政要闻</el-menu-item>
		    <el-menu-item index="2">通知公告</el-menu-item>
		    <el-menu-item index="4">工作动态</el-menu-item>
		  </el-submenu>
		  <el-submenu index="33">
		    <template slot="title">信息公开</template>
		    <el-menu-item index="5">党务公开</el-menu-item>
		    <el-menu-item index="6">行风建设</el-menu-item>
		  </el-submenu>
		  <el-submenu index="34">
		    <template slot="title">业务指南</template>
		    <el-menu-item index="9">缴存</el-menu-item>
		    <el-menu-item index="10">提取</el-menu-item>
			<el-menu-item index="11">贷款</el-menu-item>
		  </el-submenu>
		  <el-menu-item index="8">政策法规</a></el-menu-item>
		</el-menu>
	</div>
	<div class="ewm" v-show="ewm">
		<div class="close-button">
			<span @click="closeewm()">&times;关闭</span>
		</div>
		<div class="wxgzh">
			<img src="../assets/img/gzh.jpg" alt="" />
			<span>微信公众号</span>
		</div>
		<div class="appxz" style="margin-top: 6px;">
			<img src="../assets/img/app.jpg" alt="" />
			<span>苹果和安卓app下载</span>
		</div>
	</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "1",
				ewm:true,
			};
		},
		methods: {
			handleSelect(index) {
				this.activeIndex = index;
				if(index!=1){
					this.$router.push({path:'/list?activeIndex='+index}) 
				}else if (this.$router.currentRoute.path !== "/") {
					this.$router.push({path:'/'}) 
				}
			},
			closeewm(){
				this.ewm=false;
			}
		}
	};
</script>

<style scoped>
	.dbbj{
		background-image: url('../assets/img/bj.png');
		width: 100%;
		height: 247px;
	}
	
	.bj {
		width: 1200px;
		height: 187px;
		background-image: url('../assets/img/header.png');
		margin: 0 auto;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	
	.logo img {
		/* width: 674px; */
		width: 461px;
		height: 66px;
	}
	
	.ipone img {
		width: 193px;
		height: 41px;
	}
	
	.nav {
		width: 1200px;
		margin: 0 auto;
		line-height: 40px;
		
	}
	
	.nav ul li {
		width: 240px;
		text-align: center;
		list-style-type: none;
		font-size: 22px;
	
	}
	
	.nav ul li:hover {
		color: #48A8F0;
	}
	a{
		text-decoration: none;
	}
	
	el-menu-item:hover{
		background-color: #48A8F0;
	}
	/deep/.el-submenu__title{
		font-size: 22px;
	}
	.el-menu--horizontal > .el-menu-item.is-active {
		background: #0789ea !important;
		border-bottom: none !important;
	}
	.el-menu--horizontal > .el-menu-item.is-active:hover{
		background: #066ebb !important;
	}
	.el-menu-item{
		font-size: 18px;
	}
	
	.ewm{
		position: fixed;
		top: 20%;
		right: 90px;
		width: 130px;
		font-size: 14px;
		text-align: center;
		z-index: 1000;
		/* background-color: #ffffff; */
	}
	.close-button {
	    font-weight: bold;
		text-align: right;
	}
	.close-button span:hover {
	    cursor: pointer;
	}
	
	.wxgzh{
		background-color: #ffffff;
	}
	.appxz{
		background-color: #ffffff;
	}
	.ewm img{
		width: 130px;
		height: 130px;
	}
	
</style>
<style>
	.el-menu--horizontal > .el-submenu .el-submenu__title {
		border-bottom: none !important;
	}
	.el-menu--horizontal > .el-submenu.is-active .el-submenu__title{
		background: #0789ea !important;
	}
</style>